<template>
  <span class="mb-2 text-secondary text-component">{{translate(content.text)}}</span>
</template>

<script>
    export default {
        name: "textComponent",
        props:{
            content: Object,
            lang: String,
        },
        methods: {
            translate(text) {
                const el = document.querySelector('#placementtestapp')
                const language = {
                    fr: {
                        text: 'Pas certain? Commencez par passer notre test gratuit de grammaire et de vocabulaire en norvégien '
                    }
                }
                if (el.dataset.lang === 'fr' && this.content.text === 'Not sure? Start by taking our free Norwegian grammar and vocabulary test ') return language.fr.text
                return text
            },
        },
    }
</script>

<style scoped>

</style>